import { useState, useEffect } from "react"
import { useTranslation } from "react-i18next"
import { IconSearch } from "../utils/Icons/CustomIcons"
import useDebounce from "../../hooks/useDebounce"

type Props = {
  filter: {
    sort: string
    order: string
    searchValue: string
    reminderNumber: number | string
    statusNumber: number | string
    id: number
  }
  setFilter: any
  name: string
}

const GuestsSearch = ({ filter, setFilter, name }: Props) => {
  const { t } = useTranslation()
  const [search, setSearch] = useState("")

  const debouncedSearchTerm = useDebounce(search, 500)

  useEffect(() => {
    if (debouncedSearchTerm) {
      setFilter({ ...filter, searchValue: search })
    }

    if (search === "") {
      setFilter({ ...filter, searchValue: search })
    }
  }, [debouncedSearchTerm])

  return (
    <div className={`input-search ${name}`}>
      <input
        type="text"
        placeholder={t("placeholder.search")}
        value={search}
        onChange={(event) => setSearch(event.target.value)}
      />

      <button className="input-search__btn">
        <IconSearch />
      </button>
    </div>
  )
}

export default GuestsSearch